/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
import classNames from 'classnames';
import React from 'react';

import AliasField from 'metadata/AliasField';
import Col from 'ui-library/bs/Col';
import Row from 'ui-library/bs/Row';

export interface RegistrySettingsMemberRowProps {
  member?: {
    handle: string;
    name?: string;
    initials?: string;
  };
  index: number;
  isRegistryWritable: boolean;
  onComplete: (...args: Array<any>) => any;
  validateInitials: (...args: Array<any>) => any;
}

type State = any;

class RegistrySettingsMemberRow extends React.Component<RegistrySettingsMemberRowProps, State> {
  override state: State = {
    isBeingEdited: false,
  };

  _handleCancel = (): void => {
    this.setState({isBeingEdited: false});
  };

  _handleComplete = (newValue: string): void => {
    this.setState({isBeingEdited: false});
    this.props.onComplete(this.props.index, newValue);
  };

  _handleEdit = (): void => {
    this.setState({isBeingEdited: true});
  };

  override render(): JSX.Element {
    return (
      <Row
        className={classNames('registrySettingsTable-row u-vertical-center-items', {
          'is-beingEdited': this.state.isBeingEdited,
        })}
        dataTestAttrs={{
          component: 'RegistrySettingsMemberRow',
          element: 'root',
          key: this.props.index.toString(),
        }}
      >
        <Col xs={4} className="registrySettingsTable-col">
          {this.props.member!.handle}
        </Col>
        <Col xs={4} className="registrySettingsTable-col">
          {this.props.member!.name}
        </Col>
        <Col xs={4}>
          <AliasField
            complete={this._handleComplete}
            cancel={this._handleCancel}
            edit={this._handleEdit}
            initialAlias={this.props.member!.initials}
            initialIsBeingEdited={false}
            isWritable={this.props.isRegistryWritable}
            placeholder="Enter option name"
            validate={this.props.validateInitials}
          />
        </Col>
      </Row>
    );
  }
}

export default RegistrySettingsMemberRow;
